const cartThreshold = {
  data: {
    cart: null,
    giftCardHandle: 'digitalgiftcard'
  },
  init(cart) {
    if (!this.checkOnlyGiftExist(cart)) {
      this.getTargetVariant(cart)
    } else {
      // If only Gift item does exist in the cart, clear the cart.
      const line = 1;
      ShopifyAPI.changeItem(line, 0, () => {
        console.log('Cleared Cart!')
        if (document.body.classList.contains('template-cart')) {
          ShopifyAPI.refreshCartPage()
        } else {
          ajaxCart.load();
        }
      });
    }
  },

  getTargetVariant(cart) {
    const cartTotal = this.getCartTotal(cart);

    const rules = free_gift_rules
      .filter(rule => cartTotal >= rule.cart_threshold * 100 )
      .sort((a, b) => parseFloat(a.cart_threshold) - parseFloat(b.cart_threshold));

    if (rules.length > 0) {
      // Get the largest rule meets the cart threshold
      const rule = rules.reduce((a, b) => parseFloat(a.cart_threshold) > parseFloat(b.cart_threshold) ? a: b)
      if (rule) {
        const variantId = rule.reward_variant.split('ProductVariant/')[1]
        this.checkGiftCardStatus(variantId, cart)
      }
    } else {
      // Remove Gift Card if doesn't meet threshold
      const giftCard = cart.items.find(item => item.handle == this.data.giftCardHandle && item.properties?._free_gift_card == 'Yes')
      if (giftCard) {
        // if exist, check variant ID
        // If same variant, just skip, not same variant => remove => add the new one.
        let line = null;
        cart.items.map((item, index) => {
          if (item.id == giftCard.id) {
            line = index + 1
          }
        })

        if (line != null) {
          ShopifyAPI.changeItem(line, 0, () => {
            console.log('Removed Free Gift')
            if (document.body.classList.contains('template-cart')) {
              ShopifyAPI.refreshCartPage()
            } else {
              ajaxCart.load();
            }
          });
        }
      }
    }
  },

  // Get Cart Total without Giftcard
  getCartTotal(cart) {
    let cartTotal = 0;
    cart.items.map(item => {
      if (item.handle == this.data.giftCardHandle && item.properties?._free_gift_card == 'Yes') {
        // Free Gift
      } else if (item.handle == 'giftcard') {
      } else {
        cartTotal += item.final_line_price
      }
    })

    return cartTotal;
  },

  // Check if Gift-card only exist in cart 
  checkOnlyGiftExist(cart) {
    const giftCard = cart.items.find(item => item.handle == this.data.giftCardHandle && item.properties?._free_gift_card == 'Yes')
    if (giftCard && cart.item_count == 1) {
      return true;
    }

    return false;
  },

  // Check if Gift-card already exists in Cart or not
  checkGiftCardStatus(variantId, cart) {
    const giftCard = cart.items.find(item => item.handle == this.data.giftCardHandle && item.properties?._free_gift_card == 'Yes')
    console.log(`giftCard`, giftCard);
    if (giftCard) {
      // if exist, check variant ID
      // If same variant, just skip, not same variant => remove => add the new one.
      if (giftCard.id != variantId) {
        let line = null;
        cart.items.map((item, index) => {
          if (item.id == giftCard.id) {
            line = index + 1
          }
        })

        if (line != null) {
          ShopifyAPI.changeItem(line, 0, () => {
            this.addItem(variantId)
          });
        }
      }
    } else {
      // If doesn't exist, just add to the cart.
      this.addItem(variantId)
    }
  },

  // Add GIft Card to the cart, with line-item properties
  addItem(variantId) {
    const data = {
      id: variantId,
      quantity: 1,
      properties: {
        _free_gift_card: 'Yes'
      }
    }, callback = function(lineItem) {
      if (document.body.classList.contains('template-cart')) {
        ShopifyAPI.refreshCartPage()
      } else {
        ajaxCart.load();
      }
    }, errorCallback = function() {
      var data = eval('(' + XMLHttpRequest.responseText + ')');
      console.log(data);
    }
    ShopifyAPI.addMultipleItems(data, callback, errorCallback);
  }
}

$(document).on('ready', function(evt, cart) {
  if (typeof window.free_gift_rules !== 'undefined') {
    ShopifyAPI.getCart();
  }
});

$(document).on('afterGetCart.ajaxCart', function(evt, cart) {
  if (typeof window.free_gift_rules !== 'undefined') {
    cartThreshold.init(cart)
  }
});

class WishlistItemCount extends HTMLElement {
  constructor() {
    super();

    this.handleCountUpdated = (e) => {
      this.count = e.detail.totalItems;
    };

    this.count = window.wishlistTotalCount;
  }

  connectedCallback() {
    document.addEventListener('wishlist-count-updated', this.handleCountUpdated);
  }

  disconnectedCallback() {
    document.removeEventListener('wishlist-count-updated', this.handleCountUpdated);
  }

  set count(count) {
    this.innerHTML = count ? `(${count})` : '';
  }
}

if (!customElements.get("wishlist-item-count")) {
  customElements.define("wishlist-item-count", WishlistItemCount);
}

document.addEventListener('click', (e) => {
  if (!e.target.classList.contains('swym-share-wishlist-email-btn')) return;

  const closeBtn = e.target.closest('.swym-share-wishlist-modal-dialog')?.querySelector('.swym-close-btn');

  closeBtn?.click();
});
